import React, { useEffect, useCallback, useState} from 'react';
import HandIndicator from './HandIndicator.js';
import {NONE, LEFT, RIGHT, BOTH} from 'effects/midi/jaki/constants.js';
import {connect} from 'react-redux';

const DrumCircle = ({hand, track, number, effect}) => { 
    hand = Math.round(hand);
    let param = effect["hand" + number + "Parameter"];
    const toggleLeft = useCallback(() => {
        if (hand === LEFT) {
            param.set(NONE);
        } else if (hand === BOTH) {
            param.set(RIGHT);
        } else if (hand === RIGHT) {
            param.set(BOTH);
        } else if (hand === NONE) {
            param.set(LEFT);
        }
    }, [hand]);

    const toggleRight = useCallback(() => {
        if (hand === RIGHT) {
            param.set(NONE);
        } else if (hand === BOTH) {
            param.set(LEFT);
        } else if (hand === LEFT) {
            param.set(BOTH);
        } else if (hand === NONE) {
            param.set(RIGHT);
        }
    }, [hand]);

    let leftClass = hand === BOTH || hand === LEFT ? "left-circle toggled" : "left-circle";
    let rightClass = hand === BOTH || hand === RIGHT ? "right-circle toggled" : "right-circle";
    return (
        <div className="drum-circle">
          <HandIndicator effect={effect} number={number}/>
          <div onClick={toggleLeft}
               className={leftClass}>
          </div>
          <div className="drum-divider"/>
          <div onClick={toggleRight}
               className={rightClass}>
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
    return {
        hand: props.effect["hand" + props.number + "Parameter"].get(),
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrumCircle);
